import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { zapierQueryKeys } from "./zapierQueryKeys";

export const useQueryZapierGetIntegrationConfig = ({
  api,
  refetchOnWindowFocus,
  clubId,
  enabled,
}: {
  api: ApiType;
  refetchOnWindowFocus?: boolean;
  clubId: number;
  enabled: boolean;
}) =>
  useQuery({
    queryKey: zapierQueryKeys.getIntegrationConfig(clubId),
    queryFn: async () => (await api.zapierApi.getIntegrationConfig()).data,
    refetchOnWindowFocus,
    enabled,
  });
